import { ref } from 'vue';

const getClientBudgets = () => {
    const clientbudgets_error = ref(null);
    const clientbudgets = ref(null);

    const loadClientBudgets = async () => {
      try {
        let data = await fetch("/api/clientbudgets");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        clientbudgets.value = await data.json();

        // console.log('clientbudgets', clientbudgets.value);
      } catch (err) {
        clientbudgets_error.value = err.message;
      }
    };

    return { clientbudgets, clientbudgets_error, loadClientBudgets};
}

export default getClientBudgets;
